// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/chunks/" + ({"200":"insights","328":"postMetrics","1275":"search-insights","3524":"app"}[chunkId] || chunkId) + "-" + {"200":"42cf23e7","328":"db330518","1275":"557d3d5f","3524":"c6056002","7482":"39d10c01"}[chunkId] + ".css";
};